import "@fontsource-variable/sora";
import "@fontsource-variable/inter";
import "./styles.css";

import { initI18n } from "./i18n.js";
import { initUi } from "./ui.js";
import { initContactForm } from "./contact.js";
import { initHeroCanvas } from "./hero.js";

initI18n();
initUi();
initContactForm();

const canvas = document.getElementById("hero-canvas");
if (canvas instanceof HTMLCanvasElement) initHeroCanvas(canvas);
